import moment from "moment";
import { usePersistFilters } from "../../../hooks/usePersistFilters";

export const useGetFilters = () => {
    const { filters, handleChangeFilters,clearFilters } = usePersistFilters({
        idContrato: null,
        idPaciente: null,
        fechaDesde: moment().startOf('month').format('YYYY-MM-DD'),
        fechaHasta: moment().endOf('month').format('YYYY-MM-DD'),
    }, `borrarConexionesFilters`);

    return {
        filters,
        handleChangeFilters,
        clearFilters
    };
};